import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  position: relative;

  input:focus + .paint-img {
    img {
      filter: invert(38%) sepia(86%) saturate(2990%) hue-rotate(175deg)
        brightness(88%) contrast(105%);
    }
  }
`;
